const routerES = {
    "releases": {
        "view": {
            "name": "Lanzamientos",
            "buttonText": "Agregar Nuevo Lanzamiento",
            "secondaryButtonText": "Transferir Lanzamiento",
            "headerText": "Lanzamientos"
        },
        "add": {
            "name": "Agregar Nuevo Lanzamiento",
            "headerText": "Lanzamientos"
        },
        "update": {
            "name": "Actualizar Lanzamiento",
            "headerText": "Lanzamientos"
        },
        "details": {
            "name": "Detalles del Lanzamiento",
            "headerText": "Lanzamientos"
        },
        "transfer": {
            "name": "Transferir Lanzamiento",
            "headerText": "Lanzamientos"
        },
        "tracks": {
            "name": "Lista de Pistas",
            "headerText": "Lanzamientos"
        },
        "deliveryConfirmation": {
            "name": "Lista Entregada",
            "headerText": "Lista Entregada"
        },
        "storeDeliveryList": {
            "name": "Lista de Entrega de Tienda",
            "headerText": "Lista de Entrega de Tienda"
        }
    },
    "copyrightInfringements": {
        "view": {
            "name": "Infracciones de Derechos de Autor",
            "headerText": "Infracciones de Derechos de Autor"
        }
    },
    "escrowWallet": {
        "view": {
            "name": "Cartera de Depósito",
            "headerText": "Cartera de Depósito"
        }
    },
    "artists": {
        "view": {
            "name": "Artistas",
            "buttonText": "Agregar Nuevo Artista",
            "headerText": "Artistas"
        },
        "add": {
            "name": "Agregar Nuevo Artista",
            "headerText": "Artistas"
        },
        "update": {
            "name": "Actualizar Artista",
            "headerText": "Artistas"
        },
        "viewDetails": {
            "name": "Ver Detalles del Artista",
            "headerText": "Ver Detalles del Artista"
        },
        "wishlist": {
            "name": "Lista de Deseos de Artistas",
            "headerText": "Lista de Deseos de Artistas"
        },
        "addFromWishlist": {
            "name": "Agregar Artista Desde Lista de Deseos",
            "headerText": "Agregar Artista Desde Lista de Deseos"
        }
    },
    "trends": {
        "view": {
            "name": "Tendencias",
            "headerText": "Tendencias"
        }
    },
    "earningsDrilldown": {
        "view": {
            "name": "Ganancias",
            "headerText": "Desglose de Ganancias"
        }
    },
    "accounting": {
        "view": {
            "name": "Contabilidad Inteligente",
            "headerText": "Contabilidad Inteligente",
            "buttonText": "Agregar Nueva Contabilidad"
        },
        "add": {
            "name": "Agregar Nueva Contabilidad",
            "headerText": "Agregar Nueva Contabilidad"
        },
        "breakdown": {
            "name": "Desglose de Contabilidad",
            "headerText": "Desglose de Contabilidad"
        }
    },
    "invoices": {
        "view": {
            "name": "Facturas",
            "headerText": "Facturas",
            "buttonText": "Agregar Factura"
        },
        "add": {
            "name": "Agregar Factura",
            "headerText": "Agregar Factura"
        }
    },
    "musicLink": {
        "view": {
            "name": "Enlace de Música",
            "buttonText": "Agregar Nuevo Enlace de Música",
            "headerText": "Enlace de Música",
            "secondaryButtonText": "URL de Enlace de Música"
        },
        "add": {
            "name": "Agregar Enlace de Música",
            "headerText": "Enlace de Música"
        },
        "update": {
            "name": "Actualizar Enlace de Música",
            "headerText": "Enlace de Música"
        },
        "viewStats": {
            "name": "Ver Estadísticas de Enlace de Música",
            "headerText": "Ver Estadísticas de Enlace de Música"
        }
    },
    "musicLinkUrlpart": {
        "view": {
            "name": "Parte de URL de Enlace de Música",
            "buttonText": "Agregar Nueva Parte de URL de Enlace de Música",
            "headerText": "Parte de URL de Enlace de Música"
        },
        "add": {
            "name": "Agregar Nueva Parte de URL de Enlace de Música",
            "headerText": "Parte de URL de Enlace de Música"
        },
        "update": {
            "name": "Actualizar Parte de URL de Enlace de Música",
            "headerText": "Parte de URL de Enlace de Música"
        }
    },
    "linkLandingPage": {
        "view": {
            "name": "Página de Aterrizaje de Enlace",
            "buttonText": "Agregar Página de Aterrizaje de Enlace",
            "headerText": "Página de Aterrizaje de Enlace"
        },
        "add": {
            "name": "Agregar Página de Aterrizaje de Enlace",
            "headerText": "Página de Aterrizaje de Enlace"
        },
        "update": {
            "name": "Actualizar Página de Aterrizaje de Enlace",
            "headerText": "Página de Aterrizaje de Enlace"
        },
        "viewAnalytics": {
            "name": "Analítica de Página de Aterrizaje de Enlace",
            "headerText": "Página de Aterrizaje de Enlace"
        }
    },
    "mastering": {
        "view": {
            "name": "Masterización",
            "buttonText": "Agregar Masterización",
            "headerText": "Masterización de Audio"
        },
        "add": {
            "name": "Agregar Masterización",
            "headerText": "Masterización de Audio"
        },
        "update": {
            "name": "Actualizar Masterización",
            "headerText": "Masterización de Audio"
        },
        "viewSongs": {
            "name": "Canciones de Masterización de Audio",
            "headerText": "Canciones de Masterización de Audio"
        }
    },
    "featureRequest": {
        "view": {
            "name": "Solicitud de Función",
            "buttonText": "Nueva Solicitud de Función",
            "headerText": "Solicitud de Función"
        },
        "add": {
            "name": "Agregar Solicitud de Función",
            "headerText": "Solicitud de Función"
        }
    },
    "scWhitelist": {
        "view": {
            "name": "Lista Blanca de SC",
            "headerText": "Lista Blanca de SC"
        }
    },
    "profile": {
        "view": {
            "name": "Perfil",
            "headerText": "Mi Perfil"
        }
    },
    "announcements": {
        "view": {
            "name": "Anuncios",
            "headerText": "Anuncios"
        }
    },
    "twoFactorAuthentication": {
        "view": {
            "name": "Autenticación de Dos Factores",
            "headerText": "Autenticación de Dos Factores"
        }
    },
    "completeYourInformation": {
        "view": {
            "name": "Completa Tu Información",
            "headerText": "Completa Tu Información"
        }
    },
    "tokens": {
        "view": {
            "name": "Tokens",
            "headerText": "Tokens"
        }
    },
    "orderTokens": {
        "view": {
            "name": "Ordenar Tokens",
            "headerText": "Ordenar Tokens"
        }
    },
    "accessKeys": {
        "view": {
            "name": "Claves de Acceso",
            "headerText": "Claves de Acceso"
        }
    },
    "paymentMethods": {
        "view": {
            "name": "Métodos de Pago",
            "buttonText": "Agregar Método de Pago",
            "headerText": "Mis Métodos de Pago"
        },
        "add": {
            "name": "Agregar Método de Pago",
            "headerText": "Mis Métodos de Pago"
        },
        "update": {
            "name": "Actualizar Método de Pago",
            "headerText": "Mis Métodos de Pago"
        }
    },
    "orderCredits": {
        "view": {
            "name": "Ordenar Créditos",
            "headerText": "Ordenar Créditos"
        }
    },
    "purchaseHistory": {
        "view": {
            "name": "Historial de Compras",
            "headerText": "Historial de Compras"
        }
    },
    "subscription": {
        "view": {
            "name": "Mi Suscripción",
            "headerText": "Mi Suscripción"
        },
        "upgrade": {
            "name": "Actualizar Suscripción",
            "headerText": "Actualizar Suscripción"
        }
    },
    "subUsers": {
        "view": {
            "name": "Subusuarios",
            "buttonText": "Agregar Nuevo Subusuario",
            "headerText": "Mis Subusuarios"
        },
        "add": {
            "name": "Agregar Nuevo Subusuario",
            "headerText": "Mis Subusuarios"
        },
        "edit": {
            "name": "Editar Subusuario",
            "headerText": "Mis Subusuarios"
        }
    },
    "labels": {
        "view": {
            "name": "Sellos",
            "buttonText": "Agregar Nuevo Sello",
            "headerText": "Mis Sellos"
        },
        "add": {
            "name": "Agregar Nuevo Sello",
            "headerText": "Mis Sellos"
        },
        "edit": {
            "name": "Editar Sello",
            "headerText": "Mis Sellos"
        }
    },
    "statements": {
        "view": {
            "name": "Declaraciones",
            "headerText": "Declaraciones Financieras"
        }
    },
    "subuserStatements": {
        "viewParentUser": {
            "name": "Declaraciones de Subusuario",
            "headerText": "Declaraciones de Subusuario"
        },
        "viewSubuser": {
            "name": "Declaraciones de Usuario",
            "headerText": "Declaraciones de Usuario"
        }
    },
    "dashboard": {
        "view": {
            "name": "Página Principal",
            "headerText": "Página Principal"
        }
    }
};

export default routerES;